import React, { useState, useEffect } from 'react'
import { ProductBuilderState } from '../../state'
import { ProductParameter } from '../../../product'
import Grid from '@material-ui/core/Grid'
import makeStyles from '@material-ui/core/styles/makeStyles'
import classNames from 'classnames'
import { ProductParameterExpansion } from './expansion'
import { connect } from 'react-redux'
import { ProductBuilderParamInput } from './input'
import Button from '@material-ui/core/Button'
import Fab from '@material-ui/core/Fab'
import IconDelete from '@material-ui/icons/Delete'
import KeyboardBackspace from '@material-ui/icons/KeyboardBackspace'
import PictureAsPdf from '@material-ui/icons/PictureAsPdf'
import { ProductParameterExpansionDesignOwn } from './expansion/design-own'

const useStyles = makeStyles((theme: any) => ({
    root: {
        '& .parameter-row': {
            padding: theme.spacing(1, 0)
        },
        '& .parameter-row-expansion': {
            display: 'none',
            '&.expanded': {
                display: 'block'
            },
            '@media screen and (-webkit-min-device-pixel-ratio:0)': {
                '&.expanded': {
                    display: 'contents'
                },
            }
        },
        '& .button-label-icon': {
            marginLeft: theme.spacing(1)
        },
        '& .imagebrowser-item': {
            cursor: 'pointer',
            padding: theme.spacing(1)
        },
        '& .imagebrowser-image': {
            border: 'solid 2px transparent',
            maxHeight: '100%',
            maxWidth: '100%',
        },
        '& .imagebrowser-item:hover .imagebrowser-image,.imagebrowser-item--selected .imagebrowser-image': {
            border: 'solid 2px black'
        },
        '& .imagebrowser-label': {
            textAlign: 'center'
        },
        '& .ExpansionDesignContainer': {
            backgroundColor: '#f2f2f2',
            padding: theme.spacing(1.5),
            '& .DesignItem': {
                padding: theme.spacing(1),
                '& .MuiButton-root': {
                    backgroundColor: '#fff',
                    width: '100%',
                    padding: theme.spacing(4, 0),
                    textTransform: 'initial'
                }
            },
            '& .DesignItem.DesignItem-selected': {
                '& .MuiButton-root': {
                    backgroundColor: '#000',
                    color: '#fff'
                }
            }
        },
        '& .ParameterRow-preview': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '10px',
            '&__text': {
                margin: '12px 0'
            },
            '& img': {
                height: '100px',
                width: 'initial',
                maxWidth: '100%',
                marginTop: '12px'
            },
            '&__pdf': {
                height: '100px',
                width: 'initial',
                marginTop: '16px',
                borderRadius: '5px',
                backgroundColor: '#f2f2f2',
                boxShadow: '8px 8px 4px -4px rgba(0,0,0,0.12)'
            },
            '&__library': {
                paddingTop: '24px'
            },
            '&__description': {
                marginTop: '16px'
            },
            '&__more': {
                margin: '24px 0'
            }
        }
    }
}), { name: 'ProductParameters' })

export const productParametersRoot = (props: ProductBuilderState) => {
    const classes = useStyles(props)
    const expansionSwitch = (parameter: ProductParameter) =>
        props.dispatch({ type: 'PRODUCT_BUILDER_PARAMETER_EXPAND_REQUEST', params: parameter })

    const [showDropzone, setShowDropzone] = useState(false);
    const [filesUploaded, setFilesUploaded] = useState([]);
    const [descriptionUploaded, setDescriptionUploaded] = useState([]);

    const newFilesArray = props.productParameters.map(parameter => !!props.product.configuration[parameter.key].length && props.product.configuration[parameter.key][0].filesUploaded && !!props.product.configuration[parameter.key][0].filesUploaded.length && props.product.configuration[parameter.key][0].filesUploaded)
    const newFiles = newFilesArray.filter(item => item)

    const uploadedDescriptionArray = props.productParameters.map(parameter => !!props.product.configuration[parameter.key].length && props.product.configuration[parameter.key][0].description && props.product.configuration[parameter.key][0].description)
    const newDescription = uploadedDescriptionArray.filter(item => item).toString()

    const isDropzoneVisible = () => {
        setShowDropzone(true)
    }

    const uploadUploadedFilesArray = () => {
        setFilesUploaded(filesUploaded.concat(newFiles.flat()))
    }

    const uploadUploadedDescription = () => {
        setDescriptionUploaded(descriptionUploaded.concat(newDescription))
    }

    const deleteFile = (config, key, id) => {
        const index = filesUploaded.indexOf(filesUploaded.find( el => el.id === id))
        filesUploaded.splice(index, 1)
        props.dispatch({ type: 'PRODUCT_BUILDER_FILE_DELETE', params: { productConfiguration: config, productParameterKey: key, productParameterValueFile: id }})
    }

    useEffect(() => {
        uploadUploadedFilesArray()
        setShowDropzone(false)
    }, [ newFiles.length ]);

    useEffect(() => {
        uploadUploadedDescription()
    }, [ newDescription ]);

    useEffect(() => {
        props.removeUploadedFiles(filesUploaded, props.product.configuration, 'design')
        setFilesUploaded([])
    }, [ props.backToDefaultSettings ]);

    return <Grid container direction='column' className={classes.root}>
        {props.productParameters.map(parameter => <React.Fragment key={parameter.key}>
            <Grid item container alignItems='center' className='parameter-row'>
                <Grid item xs={3}>
                    {parameter.label}
                </Grid>
                <Grid item xs={9}>
                    <ProductBuilderParamInput
                        product={props.product}
                        parameter={parameter}
                        expansionSwitch={expansionSwitch}
                        expanded={ !props.backToDefaultSettings && props.productParameterExpandedKey === parameter.key }
                        value={props.product.configuration[parameter.key]}
                        valueChange={(value, keepOpen) =>
                            props.dispatch({
                                type: 'PRODUCT_BUILDER_PARAMETER_VALUE_SELECT',
                                params: {
                                    product: props.product,
                                    productParameters: props.productParameters,
                                    productParameterKey: parameter.key,
                                    productParameterValue: value.map(it => ({ label: it, key: it })),
                                    productParameterKeepOpen: keepOpen
                                }
                            })
                        }
                        loading={props.loading}
                        backToDefaultSettings={props.backToDefaultSettings}
                        resetSetBackToDefaultSettings={props.resetSetBackToDefaultSettings}
                    />
                </Grid>
            </Grid>
            <Grid item
                key={parameter.key + '-expansion'}
                className={classNames({ 'parameter-row-expansion': true, 'expanded': !props.backToDefaultSettings && props.productParameterExpandedKey === parameter.key })}>
                <ProductParameterExpansion
                    product={props.product}
                    parameter={parameter}
                    values={props.productParameterValues}
                    valueSelect={(value, keepOpen) => props.dispatch({
                        type: 'PRODUCT_BUILDER_PARAMETER_VALUE_SELECT',
                        params: {
                            product: props.product,
                            productParameters: props.productParameters,
                            productParameterKey: parameter.key,
                            productParameterValue: value,
                            productParameterKeepOpen: keepOpen
                        }
                    })}
                    valueSelected={props.product.configuration[parameter.key]} />
            </Grid>
            {!!props.product.configuration[parameter.key].length && props.product.configuration[parameter.key][0].filesUploaded && filesUploaded.length > 0 && <Grid item container justify='center'>
                {filesUploaded.length && filesUploaded.map(file =>
                    <div key={file.id} className='ParameterRow-preview'>
                        <div className='ParameterRow-preview__text'>Your file is uploaded</div>
                        <Fab aria-label='Delete' size='small'>
                            <IconDelete onClick={() => deleteFile(props.product.configuration, parameter.key, file.id) } />
                        </Fab>
                        {file.url.substring(file.url.length - 3) !== 'pdf' ? <img src={file.url} /> : <PictureAsPdf className='ParameterRow-preview__pdf' />}
                    </div>
                )}
                {props.product.configuration[parameter.key][0].description && <Grid item container justify='center'>
                    {descriptionUploaded.map( item => item !== '' ?
                        <div className='ParameterRow-preview'>
                            <Fab aria-label='Delete' size='small'>
                                <IconDelete onClick={() => console.log('deleted descriptio')} />
                            </Fab>
                            <p className='ParameterRow-preview__description'>{item}</p>
                        </div>
                    : null)}
                </Grid>}
                <Grid item container justify='center'>
                    <Button variant='contained' color={'primary'} className='ParameterRow-preview__more' onClick={isDropzoneVisible} >Add more</Button>
                </Grid>
               {showDropzone && <ProductParameterExpansionDesignOwn
                     back={() => {}}
                     value={props.productParameterValues.find(it => it.key === props.product.configuration[parameter.key].map(item => item.key)[0] )}
                     manual={parameter.manual}
                     valueSelect={(value) => props.dispatch({
                        type: 'PRODUCT_BUILDER_PARAMETER_VALUE_SELECT',
                        params: {
                            product: props.product,
                            productParameters: props.productParameters,
                            productParameterKey: parameter.key,
                            productParameterValue: [value],
                            productParameterKeepOpen: true
                        }
                    })}
                     valueSelected={props.product.configuration[parameter.key]}
                     twoSided={false}
                     description={props.product.configuration[parameter.key][0].description ? true : false}
                />}
            </Grid>}
            {!!props.product.configuration[parameter.key].length && props.product.configuration[parameter.key][0].key === 'library' && !!props.product.configuration[parameter.key][0].valueSelected && <Grid item container justify='center'>
                <div>
                    <Grid container justify='flex-end' onClick={() => expansionSwitch(parameter)} className={'ParameterRow-preview__library'} >
                        <KeyboardBackspace />
                        <div>Changed your mind?</div>
                    </Grid>
                    <img src={props.product.configuration[parameter.key][0].valueSelected.label} />
                </div>
            </Grid>}
        </React.Fragment>)}
    </Grid>
}

export const ProductParametersRoot =
    connect((state: any) => state.productBuilderState)(productParametersRoot)
